import { useState } from "react";
import type { BootstrapResponse } from "../types";
import { Notice } from "./WorkflowShared";
import { WorkerManagement, type WorkerControls } from "./WorkerManagement";
import { AnnouncementMessages } from "./AnnouncementMessages";
import { RobotManagement, type RobotControls } from "./RobotManagement";
import { WorkerScheduleSummary } from "./WorkerScheduleSummary";
import "./StudioAdmin.css";

/** onExit: 이 화면이 창 안에 들어가 있을 때, 그 창째로 떠나는 길. 주면 안에서 여는 폼은 새
 *  창이 아니라 한 걸음 안이 되어 ‹ 로 돌아오고, ✕ 는 창까지 통째로 닫는다. */
export function StudioAdmin({ data, refresh, actorName, canEdit = true, onExit }: { data: BootstrapResponse; refresh: () => Promise<void>; actorName: string; canEdit?: boolean; onExit?: () => void }) {
  const [message, setMessage] = useState<{ tone: "success" | "error"; text: string } | null>(null);
  const [robotControls, setRobotControls] = useState<RobotControls | null>(null);
  const [workerControls, setWorkerControls] = useState<WorkerControls | null>(null);
  const [messageSelection, setMessageSelection] = useState<Set<string>>(new Set());
  const [composeOpen, setComposeOpen] = useState(false);
  const toggleMessageRecipient = (id: string) => setMessageSelection(current => { const next = new Set(current); if (next.has(id)) next.delete(id); else next.add(id); return next; });
  const common = { data, refresh, actorName, notify: setMessage };
  // The route shell owns the page landmark; this workspace only supplies its contents.
  return <div className="studio-admin-page">
    {message && <Notice tone={message.tone}>{message.text}</Notice>}
    <div className="studio-admin-stack">
      {canEdit && <WorkerScheduleSummary data={data} refresh={refresh} actorName={actorName} robotControls={robotControls} workerControls={workerControls}
        messageSelection={messageSelection} onToggleMessageRecipient={toggleMessageRecipient} onCompose={() => setComposeOpen(true)} onExit={onExit} />
      }
      {canEdit && <WorkerManagement {...common} hideTable onExit={onExit} onReady={setWorkerControls} />}
      {canEdit && <RobotManagement data={data} refresh={refresh} notify={setMessage} hideTable onExit={onExit} onReady={setRobotControls} />}
      {canEdit && composeOpen && <AnnouncementMessages data={data} initialRecipientIds={[...messageSelection]} onClose={() => { setComposeOpen(false); setMessageSelection(new Set()); }} onExit={onExit} />}
    </div>
  </div>;
}
